import * as React from "react";
import { EmptyTree } from "../../../../components/EmptyTree/modules/EcommContent/components/VariantSelectorTree/components/EmptyTree/EmptyTree.js";
import { VariantTreeLevel } from "../../../../components/VariantTreeLevel/modules/EcommContent/components/VariantSelectorTree/components/VariantTreeLevel/VariantTreeLevel.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
const VariantSelectorTree = ({ className }) => {
  const {
    product: { variantFacetTree: unfilteredVariantFacetTree },
    activeVariant: { sku: activeSku }
  } = useProductData();
  if (!unfilteredVariantFacetTree.length) return null;
  const renderTreeLevel = (unfilteredVariantFacetTree2, rootLevel) => {
    const variantFacetTree = unfilteredVariantFacetTree2.filter(
      (treeNode) => treeNode.facetTerm !== null
    );
    const nullVariantFacetTree = unfilteredVariantFacetTree2.filter(
      (treeNode) => treeNode.facetTerm === null
    );
    const nullRootNode = nullVariantFacetTree[0];
    const skipTreeLevel = unfilteredVariantFacetTree2.length === nullVariantFacetTree.length && nullRootNode;
    const skipNodeInLevel = unfilteredVariantFacetTree2.length > nullVariantFacetTree.length && nullVariantFacetTree.length !== 0;
    if (skipNodeInLevel) {
      nullVariantFacetTree.forEach(
        (nullNode) => console.warn(
          `Variant with sku "${nullNode.sku}" has a misconfigured facet for property "${nullNode.facetKey}". This variant branch has been removed from the variant selector tree.`
        )
      );
    }
    let childBranch;
    let treeLevel = null;
    if (skipTreeLevel) {
      childBranch = nullRootNode.childFacets;
    } else {
      const currentNode = variantFacetTree.find((node) => node.skuCollection.includes(activeSku)) || variantFacetTree[0];
      childBranch = currentNode?.childFacets || [];
      treeLevel = /* @__PURE__ */ React.createElement(VariantTreeLevel, { treeLevelVariants: variantFacetTree, currentNode });
    }
    const childBranchTreeLevel = childBranch.length > 0 ? renderTreeLevel(childBranch, false) : null;
    if (childBranchTreeLevel) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, treeLevel, childBranchTreeLevel);
    } else if (!treeLevel && rootLevel) {
      return /* @__PURE__ */ React.createElement(EmptyTree, { treeVariants: unfilteredVariantFacetTree2 });
    } else {
      return treeLevel;
    }
  };
  return /* @__PURE__ */ React.createElement("div", { "data-t": "variant-selector-tree", className }, renderTreeLevel(unfilteredVariantFacetTree, true));
};
export {
  VariantSelectorTree
};
//# sourceMappingURL=VariantSelectorTree.js.map
